<template>
<span v-if="remedial">  
      <p class="w3-hide-small">
          <font color="green"><b>Here you can process new/existing remedials.  Click the Refresh button to load background changes such as notes, pictures, activities.</b></font>
      </p>

      <h3>{{remedial.business.name}}</h3>
      <tablink-layout style="margin-top:10px" show="notes">    
        <tab-link-button v-if="AuthsRemedialRights({remedial,check:'createremedials'})" id="remedial">Remedial</tab-link-button>          
        <tab-link-button v-if="AuthsRemedialRights({remedial,check:'createremedials'})" id="status">Status</tab-link-button>
        <tab-link-button id="notes">About</tab-link-button>                  
        <tab-link-button id="pictures">Pictures</tab-link-button>                  
        <tab-link-button id="activities">Activities</tab-link-button>    
      </tablink-layout>

      <tab-layout id="status_tab">
        <h3>Remedial Status</h3>  
        <p>
          <b><font color="green">Set the status of the remedial.</font></b> 
        </p>     
        <status-selector :statuses="templateconfig.statuses" type="list" v-model="remedial.status"/>        
    </tab-layout>

      <tab-layout id="pictures_tab">
         <!-- <p v-if="business.image" class="w3-container w3-center">
            <img :src="business.image" height="100px" class="w3-image" alt="home image"/>
        </p>  -->
        <p>
          <b><font color="green">NOTE!! When adding an image you do not need to save as this happens in the background and in the cloud. It also takes some time to resize the image so please allow time for this to process</font></b> 
        </p>       

        <image-editor v-if="AuthsRemedialRights({remedial,check:'allowimageupload'})" :config="{id:remedial.id,business_id:remedial.business.id, location:`/remedials/businesses/${remedial.business.id}/processingremedials`,linkedbusinesslocation:`/remedials/businesses/${remedial.linkedbusiness.id}/processingremedials`,maxsize:10}"/> 
        <image-dialog ref="imagedialog">
          <template slot-scope="{image}">
              <p>
                  <label>Title</label>
                  <input type="text" class="w3-input w3-border" style="resize:none" v-model="image.title"/>            
              </p>
              <!-- {{image}} -->
              <save-button @click="$emit('tabsActions',{action:'saveImage',data:{image}});$refs.imagedialog.cancelDialog()" class="w3-theme-action"/>
           </template>
        </image-dialog>

        <ol class="w3-ul">
            <li :key="index" v-for="(image,index) in remedial.images">                
                <b>{{image.title || 'No Title'}}&nbsp;&nbsp;</b><a href="#" @click="$refs.imagedialog.show({id:index, url:image.url,title:image.title})">Open Editor<i class="fa fa-pencil-alt"/></a> 
                &nbsp;&nbsp;&nbsp;&nbsp;<a href="#" @click="openfullscreen(image.url)">Full Screen<i class="fa fa-chrome"/></a> 
                

            </li>
        </ol>
      
      </tab-layout>

      <tab-layout id="activities_tab">

        <ul class="w3-ul">
            <li :key="index" v-for="(activity,index) in remedial.activities">
                <b>{{activity.user.name}}</b> {{activity.action}} - <b>{{activity.actionedAt|formatDate}}</b><br>
            </li>
        </ul>
      
      </tab-layout>

      <tab-layout id="notes_tab">
          <h4><u>Remedial Info</u></h4>
          <span>   
            <p v-if="remedial.shortid">
              Unique Id: <b>{{remedial.shortid}}</b> Status: <span :class="remedial.status | statustype('colour')"><b>{{remedial.status | statustype('name') }}</b></span>    
            </p>
        
            <p>
              <label >{{remedial.type | remedialtype}}: <b>{{remedial.linkedbusiness.name}}</b> <span v-if="remedial.linkedstatus" :class="remedial.linkedstatus | statustype('colour')">(<b>{{remedial.linkedstatus | statustype('name')}}</b>)</span></label> 
            </p>   
            <p>  
              <label>Job/Remedial# : <b>{{remedial.jobnumber}}</b></label>
            </p>        
            <p>
              <label>PO/Reference # : <b>{{remedial.referencenumber}}</b></label>            
            </p>
            <p>                      
              <label >Issue: <b>{{remedial.issue}}</b></label>            
            </p> 
            <p>                    
              <label >Contact Info: <b>{{remedial.address}}</b></label>                        
            </p>
            <p>                    
              <label >Assigned <span v-if="remedial.assigned"><b>({{remedial.assigned.knownAs}})</b></span></label>                      
            </p>           
        </span>
        <h4><u>Notes</u></h4>
        <ul class="w3-ul">
            <li :key="index" v-for="(note,index) in remedial.notes">
                <b>{{note.by.name}}</b> added a comment - <b>{{note.submittedAt|formatDate}}</b><br>
                <p>{{note.comment}}</p>
            </li>
        </ul>
      
      </tab-layout>

      <tab-layout id="remedial_tab">
        <remedial-layout ref="remediallayout" :remedial="remedial" :statuses="templateconfig.statuses"> 
            
        </remedial-layout>

        <slot></slot>        

      </tab-layout>

        <!-- <async-component/> -->

        <!-- <test-template :remedial="remedial"/> -->
        <!-- <asy-test :remedial="remedial"/> -->
  </span>

</template>

<script>
    import {
    mapGetters,
    mapActions
  } from "vuex";

  // var AsyncComponent = function(resolve) {
  //     // console.log(store)
  //     let temp = "<div>{{remedial}}</div>"
  //         resolve({
  //             store,
  //             template: temp,
  //             props:["remedial"],
  //         });      
  // };
  import authsMixin from '../../../.././mixins/authsMixin'
  export default {    
    props: ["remedial"],
    mixins:[authsMixin],
    methods:{   
      openfullscreen(url){
        window.open(url)
      }
    },
    computed:{
      ...mapGetters(["templateconfig","alladminrights"]),
      
    }
    // data: function() {
    //   return {          
    //       // AsyncComponent : function(resolve) {
              
    //       //     let temp = "<div>{{remedial}}</div>"
    //       //         resolve({
    //       //             template: temp,
    //       //             props:["remedial"],
    //       //         });
              
    //       // }
    //   }
    // },
    // components:{
    //     'asy-test':AsyncComponent
    //     // 'test-template':function(resolve){
            
    //     //     let temp = "<div>{{remedial}}</div>"
    //     //     console.log(this.remedial)
    //     //     setTimeout(function() {
    //     //       resolve({
    //     //           props:["remedial"],
    //     //           template:temp
    //     //       })  
    //     //     }, 2000);
              
    //     // }
    // }
    
  }
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/RemedialTabsLayout.vue